import { UserRoleType } from 'src/app/core/auth/models/user-role-types.enum';
import { CapHeaderViewConditions, CapHeaderViewPermissions } from '@cap/cap-ui';

export interface UserState {
    loading: boolean;
    loaded: boolean;

    userName: string;
    userMemberId: string;

    firstName: string;
    lastName: string;

    role: UserRoleType;

    elssHeaderItemViewPermissions: CapHeaderViewPermissions[];
    elssHeaderItemViewConditions: CapHeaderViewConditions[];
}

export const initialState: UserState = {
    loading: false,
    loaded: false,

    userName: null,
    userMemberId: null,

    firstName: null,
    lastName: null,

    role: null,

    elssHeaderItemViewPermissions: [],
    elssHeaderItemViewConditions: [],
};
